import { ProductPage } from "./product-visual-page";
import Blocks from "../blocks";

/**
 * Base class used by all product page blocks
 * 
 * */
export class ProductBlock {
    public static CLASS_NAME = "section";
    private static readonly IN_VIEW_CLASS = "in-view";
    private static readonly ACTIVATED_CLASS = "activated";
    private static readonly IN_VIEW_DEFAULT_OFFSET = 25;
    private static readonly IN_VIEW_DEFAULT_OFFSET_DESKTOP = 45;

    protected element: JQuery;
    protected inViewPos: number;     // Scroll pos when in view
    protected outOfViewPos: number;  // Scroll pos when out of view

    protected isInView: boolean;
    protected isActivated: boolean;

    private resizeTimer: ReturnType<typeof setTimeout>;
    private windowWidth: number;

    constructor(e: HTMLElement) {
        this.element = $(e);
        this.windowWidth = $(window).width();
        this.setListeners();
    }

    public initiate() {
        const topPos = this.element.offset().top;
        const botPos = topPos + this.element.height();

        const windowHeight = $(window).height();
        const bodyPadding = parseInt($("body").css("paddingBottom"));

        const inViewOffset = this.element.data("in-view-offset");

        const inViewDefaultOffset = ProductBlock.isMobile() ?
            ProductBlock.IN_VIEW_DEFAULT_OFFSET :
            ProductBlock.IN_VIEW_DEFAULT_OFFSET_DESKTOP;

        const inViewOffsetPercent = typeof inViewOffset !== "undefined" ?
            parseInt(inViewOffset) : inViewDefaultOffset;

        const inViewOffsetValue = this.element.height() * (inViewOffsetPercent / 100);

        this.inViewPos = topPos - windowHeight + bodyPadding + inViewOffsetValue;
        this.outOfViewPos = botPos;

        if (ProductPage.Debug) {
            this.setDebugData();
        }

        this.onScroll();
    }

    public static inEdit(): boolean {
        return $("html").hasClass("in-edit");
    }

    public static isMobile(): boolean {
        let win = window as any;
        let isMobileDevice = win.Helpers ? win.Helpers.isMobile.any() : false;

        return isMobileDevice || $(window).width() < Blocks.desktopBreakpoint;
    }

    private setListeners() {
        $(window).on("scroll", this.onScroll.bind(this));
        $(window).on("resize", this.onResize.bind(this));
    }

    protected onScroll() {
        const currScrollPos = window.pageYOffset;

        if (this.isInView && currScrollPos > this.outOfViewPos) {
            this.outOfView();
        }
        else if (!this.isInView &&
            currScrollPos < this.outOfViewPos &&
            currScrollPos > this.inViewPos) {
            this.inView();
            this.activate();
        }
    }

    private onResize() {
        clearTimeout(this.resizeTimer);

        this.resizeTimer = setTimeout(() => {
            const currentWidth = $(window).width();

            if (this.windowWidth !== currentWidth) {
                this.initiate();
            }

            this.windowWidth = currentWidth;

        }, 150);
    }

    protected inView() {
        this.isInView = true;
        this.element.addClass(ProductBlock.IN_VIEW_CLASS);
    }

    protected outOfView() {
        this.isInView = false;
        this.element.removeClass(ProductBlock.IN_VIEW_CLASS);
    }

    protected activate() {
        this.isActivated = true;
        this.element.addClass(ProductBlock.ACTIVATED_CLASS);
    }

    protected setDebugData() {
        if (ProductPage.Debug) {
            this.element.attr("data-in-view", this.inViewPos);
            this.element.attr("data-out-view", this.outOfViewPos);
        }
    }
}